<template>
  <tv-page title="TV标销-套餐详情" :class="_.page">
    <template>
      <div v-if="detail" :class="_.goods_detail">
        <div
          ref="left"
          v-focusable
          :class="[_.left, 'no-focused-style']"
          v-on="leftListeners"
        >
          <template v-if="type === 0">
            <van-swipe
              class="my-swipe"
              indicator-color="white"
              :show-indicators="false"
              :autoplay="3000"
            >
              <van-swipe-item v-for="item in detail.carousePic" :key="item">
                <img :src="item" :class="_.cover" />
              </van-swipe-item>
            </van-swipe>
            <div :class="_.tc">
              <p :class="_.title">套餐详情</p>
              <div
                v-for="item in detail.writeOffCombos"
                :key="item"
                :class="_.content"
              >
                <p :class="_.subhead">{{ item.groupName }}</p>
                <ul>
                  <li v-for="items in item.groupDetails" :key="items">
                    <span>{{ items.serviceName }}</span>
                    <span :class="_.number">x{{ items.num }}</span>
                    <span>￥{{ items.price }}</span>
                  </li>
                </ul>
              </div>
              <p v-if="detail.dashPrice" :class="_.price">
                <span>套餐总价值</span>
                <span>￥{{ detail.dashPrice }}</span>
              </p>
              <p v-if="detail.commodityDetail" :class="_.title">图文详情</p>
            </div>
            <div :class="_.detail" v-html="detail.commodityDetail"></div>
          </template>

          <div :class="_.notice">
            <div v-if="type === 1" :class="_.coupon">
              <p :class="_.title">{{ detail.commodityTitle }}</p>
              <p :class="_.sum">
                {{ `${detail.lowestPrice}元代${detail.dashPrice}元券` }}
              </p>
              <p :class="_.data">{{ detail.commoditySubTitle }}</p>
            </div>
            <p v-if="detail.purchaseNotesDetail" :class="_.title">购买须知</p>
            <div :class="_.content" v-html="detail.purchaseNotesDetail" />
          </div>
        </div>
        <div :class="_.right">
          <p v-if="type === 0" :class="[_.title, 'no-focused-style']">
            {{ detail.commodityTitle }}
          </p>
          <p v-else :class="_.title">
            {{ `${detail.lowestPrice}元代${detail.dashPrice}元券` }}
          </p>
          <div :class="_.collect">
            <img
              v-for="c in detail.store.evaluateStat"
              :key="c"
              src="./images/收藏.png"
            />
            <img
              v-for="c in 5 - detail.store.evaluateStat"
              :key="c"
              src="./images/未收藏1.png"
            />
            <span>{{ detail.store.evaluateStat }}.0</span>
          </div>
          <div v-if="type === 0" :class="_.mj">
            <span v-for="item in fullCoupons" :key="item.activityId">{{
              item.describe
            }}</span>
          </div>
          <div :class="_.hint">
            <div v-if="discounts.length" :class="_.discounts">
              <span :class="_.hint_span">折扣优惠：</span>
              <div>
                <p v-for="item in discounts" :key="item.activityId">
                  {{ item.describe }}
                </p>
              </div>
            </div>
            <p>
              <span :class="_.hint_span">使用方式：</span>
              <span>支付后请持多彩宝APP到店使用</span>
            </p>
            <div :class="_.discounts">
              <span :class="_.hint_span">适用门店：</span>
              <div :class="_.store">
                <p>{{ detail.store.storeName }}</p>
                <p>
                  <img src="./images/电话.png" />
                  <span>{{ detail.store.storePhone }}</span>
                </p>
                <p>
                  <img src="./images/地址.png" />
                  <span>{{ detail.store.address }}</span>
                </p>
              </div>
            </div>
          </div>
          <div :class="_.buy">
            <p>
              团购价：
              <span :class="_.lowestPrice">¥{{ detail.lowestPrice }}</span>
              <span v-if="detail.dashPrice" :class="_.dashPrice"
                >¥{{ detail.dashPrice }}</span
              >
            </p>
            <span
              v-if="storeStatus === 2"
              ref="buy"
              v-focusable
              :class="_.submit"
              @click="buyListeners"
              >立即购买</span
            >
            <span v-if="storeStatus === 4" :class="_.submit">店铺休息中</span>
            <span v-if="storeStatus === 3" :class="_.submit">店铺已停业</span>
          </div>
        </div>
      </div>
      <Overlay :show="showOverlay">
        <div :class="_.overlay">
          <span
            ref="explain"
            v-focusable
            :class="_.agreement"
            @click="handleClickExplain"
            >支付即同意《退款说明》</span
          >
          <div :class="_.dialog">
            <p :class="_.title">确认订单</p>
            <p>
              <span>{{ detail.commodityTitle }}</span>
            </p>
            <p>
              <span
                >优惠券<span :class="_.remark">(自动使用最大优惠)</span></span
              >
              <span v-if="maxCoupons"
                >{{ maxCoupons.minPointAmt
                }}{{ maxCoupons.discountedAmt }}</span
              >
              <span v-else>无可用优惠券</span>
            </p>
            <p v-if="discountsValue">
              <span>优惠金额</span>
              <span>
                <span :class="_.hint">优惠金额包含优惠券满减折扣等</span>
                <span :class="_.money">￥{{ discountsValue.toFixed(2) }}</span>
              </span>
            </p>
            <!--            日期库存状态展示预约时间-->
            <template v-if="detail.stockType === 3">
              <p>可预约时间</p>
              <div ref="time" :class="_.time">
                <div
                  v-for="(item, index) in dateList"
                  :key="item.stockDate"
                  v-focusable
                  v-on="timeListeners"
                >
                  <p>{{ item.stockDate.replace(/-/g, '/') }}-{{ item.week }}</p>
                  <p>￥{{ item.sellPrice }}</p>
                  <img
                    v-if="checked === index"
                    :class="_.active"
                    src="./images/选中.png"
                  />
                </div>
              </div>
            </template>
            <p :class="_.sum">
              <span>订单金额</span>
              <span v-if="price >= 0" :class="_.price"
                >￥{{ price.toFixed(2) }}</span
              >
            </p>
            <span ref="pay" v-focusable :class="_.pay" v-on="payListeners"
              >确认并支付</span
            >
          </div>
        </div>
      </Overlay>
      <div v-if="errorPage" :class="_.empty">
        <div>
          <img src="./images/空.png" />
          <p :class="_.message">该商品已下架~</p>
        </div>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiCommodityWriteOffCommodityDetail,
    apiCommodityWriteOffCommodityMarketingDetail,
    apiCommodityWriteOffCommoditySkuDetail,
    apiMarketingCouponMyCouponUsableList,
    apiMarketingCouponReceiveOpen,
    apiTradeGeneralTradePreOrder,
    apiTradeGeneralTradeTradeOrder,
  } from '@/api'
  import { currentSaleChannelId } from '@/channel'
  import { dcb } from '@dcb/jssdk'
  import { defineTvListeners } from '../../utils'
  import { mapQuery, Track } from '@/utils'
  import { navigateTo } from '../../../../router'
  import { newRouteOnValueChange } from '../../../../utils'
  import { Overlay } from 'vant'

  export default Vue.extend({
    components: {
      Overlay,
    },
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: 'TV标销-套餐详情',
      })),
      mapQuery({
        // 套餐 ID
        id: {
          key: ['id', 'goodsId'],
        },
      }),
    ],

    data() {
      return {
        // 页面加载状态
        loading: true,
        collectValue: 4,
        showOverlay: false,
        checked: '',
        detail: '',
        type: '', //商品种类0-套餐券 1-代金券
        fullCoupons: [], //满减优惠
        discounts: [], //折扣优惠
        dateList: [], //预约时间
        price: 0, //订单金额
        maxCoupons: '', //最大优惠的优惠券数据
        buyDate: '', // 购买日期
        params: '', //预下单参数
        preOrderData: '', //预下单返回数据
        discountData: '', //最大优惠金额
        rule: '', //退款规则
        discountsValue: 0, //已优惠金额
        errorPage: false, //判断异常页面展示
        storeStatus: '', //店铺状态
        //跳到退款说明按钮
        goToExplain() {
          this.$tv.goTo(this.$refs.explain)
        },

        //跳到预约时间
        goToTime(index) {
          this.$tv.goTo(this.$refs.time, index - 1)
        },

        //跳到立即购买
        goToBuy() {
          if (this.$refs.buy) {
            this.$tv.goTo(this.$refs.buy)
          } else {
            this.$tv.goTo(this.$refs.left)
          }
        },

        //跳到确认并支付按钮
        goToPay() {
          this.$tv.goTo(this.$refs.pay)
        },
        leftListeners: defineTvListeners(({ type }) => {
          switch (type) {
            case 'down':
              this.down(this.$refs.left)
              break
            case 'up':
              this.up(this.$refs.left)
              break
            default:
              break
          }
        }),

        //预约时间的监听
        timeListeners: defineTvListeners(({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'focus':
              this.$tv.setScrollEl(this.$refs.time)
              break
            case 'left':
              if (isFirst) {
                this.$tv.resetScrollEl()
                this.goToExplain()
              } else {
                this.goToTime(index)
              }
              break
            case 'right':
              if (isLast) {
                this.$tv.resetScrollEl()
                this.goToPay()
              }
              break
            case 'down':
              this.$tv.resetScrollEl()
              this.goToPay()
              break
            case 'click':
              this.$tv.resetScrollEl()
              this.handleClicktime(index)
              break
            default:
              break
          }
        }),
        //确认并支付按钮监听
        payListeners: defineTvListeners(({ type }) => {
          switch (type) {
            case 'down':
              this.goToPay()
              break
            case 'up':
              this.goToTime(0)
              break
            case 'left':
              this.goToPay()
              break
            case 'right':
              this.goToPay()
              break
            case 'click':
              this.handleClickSubmit()
              break
            default:
              break
          }
        }),
      }
    },

    watch: {
      showOverlay(newName) {
        if (newName === false) {
          this.goToBuy()
        }
      },
    },

    async mounted() {
      await this.getMarketingDetail()
      await this.getCommodityDetail()
      this.loading = false
      this.$nextTick(() => {
        this.goToBuy()
      })

      newRouteOnValueChange({
        // @ts-ignore
        ctx: this,
        valueName: 'showOverlay',
        // @ts-ignore
        callback: showOverlay => (this.showOverlay = showOverlay),
      })
    },

    methods: {
      //监听详情往上滚动事件
      up(event) {
        event.scroll({
          top: event.scrollTop - (window.innerHeight * 2) / 3,
          left: 0,
          behavior: 'smooth',
        })
      },
      //监听详情往下滚动事件
      down(event) {
        event.scroll({
          top: event.scrollTop + (window.innerHeight * 2) / 3,
          left: 0,
          behavior: 'smooth',
        })
      },

      //获取数据详情
      getCommodityDetail() {
        return apiCommodityWriteOffCommodityDetail(
          {
            commodityId: this.id,
          },
          {
            noErrorToast: true,
          },
        )
          .then(res => {
            this.detail = res
            this.type = res.commodityClassifyType
            this.storeStatus = res.store.storeStatus
            if (this.detail.stockType === 3) {
              this.price = this.detail.lowestPrice
            } else {
              this.maxCouponsFun()
            }
          })
          .catch(() => {
            this.errorPage = true
          })
      },

      //查询营销信息
      getMarketingDetail() {
        return apiCommodityWriteOffCommodityMarketingDetail({
          commodityId: this.id,
          skuId: this.id,
        }).then(res => {
          this.fullCoupons = res.fullCoupons
          this.discounts = res.discounts

          if (this.fullCoupons.length) {
            this.fullCoupons.forEach(i => {
              this.getCoupon(i.activityId)
            })
          }
        })
      },
      //公开触发领券
      getCoupon(id) {
        apiMarketingCouponReceiveOpen(
          {
            couponActId: id, //优惠ID
          },
          {
            noErrorToast: true,
          },
        )
      },

      //获取规格信息
      getSkuDetail() {
        apiCommodityWriteOffCommoditySkuDetail({
          commodityId: this.id,
        }).then(res => {
          const data = res
          this.dateList = data.length > 7 ? data.slice(0, 6) : data
          this.dateList.forEach(i => {
            i.week = this.getWeek(i.stockDate)
          })
          //跳到确认并支付
          this.goToPay()
          this.handleClicktime(0)
        })
      },

      getWeek(dateString) {
        const dateArray = dateString.split('/')
        const weekArray = ['日', '一', '二', '三', '四', '五', '六']
        const week = weekArray[new Date(dateArray).getDay()] //注意此处必须是先new一个Date
        return `周${week}`
      },

      //立即购买点击事件
      buyListeners() {
        //判断有日期库存就弹框获取日期库存，否则就直接预下单并获取可用优惠券信息
        if (this.detail.stockType === 3) {
          //库存类型： 0-标准库存 3-日期库存
          this.getSkuDetail()
          this.showOverlay = true
        } else {
          this.getTradePreOrder()
        }
      },
      //预约时间点击事件
      handleClicktime(index) {
        this.buyDate = this.dateList[index].stockDate
        this.checked = index
        this.getTradePreOrder()
      },

      //点击退款说明
      handleClickExplain() {
        this.buyDate = this.dateList.length ? this.dateList[0].stockDate : ''
        this.getTradePreOrder('Explain')
      },
      //预下单
      getTradePreOrder(type) {
        this.preOrderData = ''
        return apiTradeGeneralTradePreOrder({
          preOrderType: 2, //预下单类型 1购物车下单 2直接下单 3秒杀下单
          skuInfo: [
            {
              commodityId: this.id,
              count: 1,
              sellChannelId: currentSaleChannelId,
              skuId: this.id,
              stockDate: this.buyDate ? this.buyDate : undefined,
            },
          ],
        }).then(res => {
          if (type === 'Explain') {
            this.rule = res.orderInfo[0].writeOffRefund
            navigateTo('TvBookGoodsExplain', {
              rule: JSON.stringify(this.rule),
            })
            return
          }
          this.preOrderData = res
          this.discountData = this.preOrderData.discountItems
          if (!this.showOverlay) {
            this.goToPay()
          }
          this.showOverlay = true
          this.getCouponUsableList()
        })
      },

      //获取可用优惠券列表
      getCouponUsableList() {
        const sumList = this.discountData.length
          ? this.discountData.map(itemnew => {
              return itemnew.amount
            })
          : []
        const sum = this.discountData.length
          ? sumList.reduce((n, m) => n + m)
          : 0
        apiMarketingCouponMyCouponUsableList({
          amt: this.preOrderData.orderAmount - sum, //订单金额
          businessType: this.preOrderData.businessType, //业务类型
          discountedAmt: sum, //订单优惠金额
          goodsIdList: [this.id], //商品ID列表
          unitOrgCode: this.preOrderData.unitOrgCode, //子机构编码
        }).then(res => {
          this.maxCoupons = res.length ? res[0] : ''
          this.maxCouponsFun(sum)
        })
      },
      maxCouponsFun(sum) {
        if (this.detail.stockType === 3) {
          //存在预约时间选择（库存类型： 0-标准库存 3-日期库存）
          if (this.maxCoupons) {
            this.price =
              this.dateList[this.checked].sellPrice -
              this.maxCoupons.discountedAmt -
              sum
            this.discountsValue = this.maxCoupons.discountedAmt + sum
          } else {
            this.price = this.dateList[this.checked].sellPrice - sum
            this.discountsValue = sum
          }
          console.log(this.price)
          console.log(this.discountsValue)
        } else {
          if (this.maxCoupons) {
            this.price =
              this.detail.lowestPrice - this.maxCoupons.discountedAmt - sum // 订单金额减去优惠券金额减去优惠项目金额
            this.discountsValue = this.maxCoupons.discountedAmt + sum
          } else {
            this.price = this.detail.lowestPrice - sum
            this.discountsValue = sum
          }
        }
      },
      //确认并支付
      async handleClickSubmit() {
        if (this.detail.stockType === 3) {
          //存在预约时间选择（库存类型： 0-标准库存 3-日期库存）
          if (this.checked === '') {
            this.$toast('请选择预约时间')
            return
          }
        }

        if (!this.preOrderData) {
          this.getTradePreOrder()
          return
        }
        //立即下单
        this.params = await apiTradeGeneralTradeTradeOrder({
          preOrderId: this.preOrderData.preOrderId,
          couponId: this.maxCoupons ? this.maxCoupons.couponId : '',
          discountAmount: this.maxCoupons ? this.maxCoupons.discountedAmt : '',
          tradeOrderInfo: {
            orderId: this.preOrderData.orderInfo[0].orderId,
            count: 1,
          },
        })
        this.getCouponUsableList()
        await dcb.requestPayment({
          provider: 'native',
          showNativeResultPage: false,
          params: this.params,
        })
        navigateTo('TvBookGoodsResult')
      },
    },
  })
</script>

<style lang="scss" module>
  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;

    img {
      width: 300px;
      height: 300px;
    }

    .message {
      margin-top: 20px;
      font-size: 36px;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
    }
  }

  .overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;

    .agreement {
      position: absolute;
      top: 40px;
      left: 40px;
      display: block;
      font-size: 24px;
      color: #ffffff;
      width: 400px;
      height: 75px;
      line-height: 75px;
      background: rgba(0, 0, 0, 0.55);
      border: 2px solid #a29d9c;
      text-align: center;
      &[focused] {
        position: absolute;
        top: 40px;
        left: 40px;
      }
    }

    .dialog {
      width: 780px;
      background: #ffffff;
      border-radius: 16px;
      padding: 40px;
      font-size: 30px;
      color: #333333;
      line-height: 44px;

      .title {
        font-size: 46px;
        font-weight: bold;
        color: #333333;
        line-height: 46px;
        margin-bottom: 40px;
        justify-content: center;
      }

      p {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .remark {
          color: #999999;
        }

        .discounts {
          font-size: 30px;
          font-weight: bold;
          color: #ff3b30;
          line-height: 44px;
        }

        .price {
          font-size: 50px;
          font-weight: bold;
          color: #ff3b30;
          line-height: 60px;
        }

        .hint {
          font-size: 20px;
          color: #858585;
          line-height: 29px;
        }

        .money {
          font-size: 30px;
          color: #ff3b30;
          line-height: 44px;
          margin-left: 10px;
        }
      }

      .pay {
        display: block;
        font-size: 40px;
        line-height: 100px;
        width: 780px;
        height: 100px;
        color: #333333;
        border-radius: 50px;
        text-align: center;
        margin-top: 66px;
        border: 1px solid #999999;

        &[focused] {
          color: #ffffff;
          border: 1px solid #ffffff;
          background: linear-gradient(312deg, #ff6d00 0%, #ffd31a 100%);
        }
      }

      .sum {
        padding-top: 40px;
        border-top: 1px solid #cccccc;
      }

      .time {
        display: flex;
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        line-height: 40px;
        white-space: nowrap;
        overflow-y: hidden;
        margin-bottom: 39px;

        div {
          padding: 20px 30px;
          background: #f5f5f5;
          margin-right: 20px;
          border-radius: 16px;
          position: relative;

          &[focused] {
            background-color: #fcd209;
            border-color: #fcd209;
            transform: scale(1);
          }

          p {
            justify-content: center;
            margin-bottom: 0;
          }

          p:first-child {
            margin-bottom: 10px;
          }
        }

        .active {
          position: absolute;
          background: url('./images/选中.png') no-repeat;
          width: 60px;
          height: 61px;
          bottom: 0;
          right: 0;

          &[focused] {
            background-color: #f5f5f5;
            border-color: #f5f5f5;
            transform: scale(1);
          }
        }
      }
    }
  }

  .page {
    background: url('./images/背景.png') no-repeat;
    background-size: cover;
    height: 100vh;
  }

  .goods_detail {
    display: flex;
  }

  .left::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .left::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 4px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #806040;
  }

  .left::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }

  .left {
    background: #402b21;
    width: 960px;
    height: 100vh;
    overflow-y: scroll;

    &[focused] {
      position: relative;
      outline: 4px solid #ffffff;
      outline-offset: -4px;
      z-index: 999;
    }

    .cover {
      width: 100%;
      height: 540px;
      object-fit: cover;
    }

    .title {
      font-size: 40px;
      color: #b2aaa6;
      line-height: 58px;
      margin-bottom: 20px;
    }

    .tc,
    .notice {
      padding: 40px 80px 10px 80px;
      font-size: 26px;
      color: #ffffff;
      line-height: 37px;

      .content {
        margin-bottom: 22px;

        img {
          width: 100%;
          height: auto;
        }
      }

      .price {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 78px;

        span:last-child {
          font-size: 32px;
          font-weight: bold;
          color: #ff3b30;
          line-height: 46px;
          margin-left: 41px;
        }
      }

      .subhead {
        margin-bottom: 18px;
      }

      ul {
        li {
          font-size: 26px;
          color: #ffffff;
          line-height: 37px;
          margin-bottom: 20px;
          padding-left: 30px;
          position: relative;
          display: flex;

          span {
            display: block;
          }

          span:first-child {
            width: 580px;
          }

          .number {
            width: 96px;
            text-align: right;
          }

          span:last-child {
            width: 120px;
            text-align: right;
          }
        }

        li::after {
          content: '';
          width: 5px;
          height: 5px;
          background: #ffffff;
          position: absolute;
          border-radius: 5px;
          left: 10px;
          top: 15px;
        }
      }
    }

    .detail {
      padding: 0 80px 0 80px;
      font-size: 26px;
      color: #ffffff;
      line-height: 37px;

      img {
        width: 100%;
        height: auto;
      }
    }

    .notice {
      .title_content {
        margin-bottom: 20px;
        padding-left: 30px;
        position: relative;
      }

      .title_content::after {
        content: '';
        width: 5px;
        height: 5px;
        background: #ffffff;
        position: absolute;
        border-radius: 5px;
        left: 10px;
        top: 15px;
      }

      .coupon {
        background: url('./images/代金券1.png') no-repeat;
        background-size: contain;
        width: 680px;
        height: 215px;
        padding: 30px;
        margin-bottom: 40px;

        .title {
          font-size: 38px;
          color: #856f41;
          line-height: 38px;
          margin-bottom: 30px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .sum {
          font-size: 60px;
          font-weight: bold;
          color: #333333;
          line-height: 60px;
          margin-bottom: 55px;
        }

        .data {
          font-size: 32px;
          color: #856f41;
          line-height: 38px;
        }
      }
    }
  }

  .right {
    width: 940px;
    padding: 80px 60px 50px 60px;

    .title {
      font-size: 40px;
      color: #ffffff;
      line-height: 58px;
      margin-bottom: 20px;
    }

    .collect {
      display: flex;
      font-size: 30px;
      color: #ff960a;
      line-height: 30px;
      margin-bottom: 28px;

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }

      span {
        margin-left: 10px;
      }
    }

    .mj {
      font-size: 32px;
      color: #ff3b30;
      line-height: 44px;
      margin-bottom: 20px;

      span {
        display: inline-table;
        padding: 10px 20px;
        border: 1px solid #ff3b30;
        border-radius: 8px;
        margin-right: 20px;
        margin-bottom: 10px;
      }
    }

    .hint {
      font-size: 28px;
      color: #ada9a5;
      line-height: 40px;

      .discounts {
        margin-bottom: 20px;
        display: flex;
        margin-left: 0;
        justify-content: flex-start;

        .hint_span {
          width: 140px;
        }

        div {
          width: 718px;
          margin-left: 0;

          p {
            margin-bottom: 0;
          }
        }

        .store {
          p {
            margin-bottom: 15px;
            display: flex;

            img {
              margin-top: 5px;
            }
          }
        }
      }

      p {
        margin-bottom: 20px;
        display: flex;

        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }

    .buy {
      position: absolute;
      bottom: 56px;

      p {
        font-size: 28px;
        color: #ada9a5;
        line-height: 40px;

        .lowestPrice {
          font-size: 80px;
          color: #ff3b30;
          line-height: 116px;
          margin-left: 10px;
          margin-right: 20px;
        }

        .dashPrice {
          font-size: 32px;
          color: #ada9a5;
          line-height: 46px;
          text-decoration: line-through;
        }
      }

      .submit {
        display: block;
        width: 828px;
        height: 128px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 70px;
        --border-radius: 80px;
        font-size: 50px;
        color: #ffffff;
        text-align: center;
        line-height: 128px;
        margin-top: 30px;

        &[focused] {
          background: linear-gradient(312deg, #ff6d00 0%, #ffd31a 100%);
        }
      }
    }
  }
</style>
